
import { Options, Vue } from "vue-class-component";
import { checkinsCollection } from "../firebase";
import { StudentRecord } from "../interfaces/student";

import moment from "moment";

@Options({
  computed: {
    studentsInSeat(): Map<string, StudentRecord> | null {
      return this.seatArray.map((seatNumber: string) => {
        if (seatNumber) {
          return this.students.get(seatNumber);
        }
        return null;
      });
    },
  },
  methods: {
    moment: function (checkinTime: number): string {
      if (checkinTime) {
        return moment(checkinTime).format("HH:mm");
      }
      return "";
    },

    buttonClass(checkinTime: number) {
      return {
        "btn-secondary": checkinTime === undefined,
        "btn-danger": checkinTime >= this.lateTime,
        "btn-warning":
          checkinTime >= this.bufferTime && checkinTime < this.lateTime,
        "btn-success": checkinTime < this.bufferTime,
      };
    },

    confirmCheckin(seatNumber: string) {
      this.targetSeatNumber = seatNumber;
      this.openConfirm = true;
    },

    closeConfirm() {
      this.openConfirm = false;
      this.targetSeatNumber = "";
    },

    async checkin() {
      const data = {
        [this.targetSeatNumber]: +new Date(),
      };

      try {
        await checkinsCollection.doc(this.dayKey).update(data);
      } catch (err) {
        await checkinsCollection.doc(this.dayKey).set(data);
      }
      this.closeConfirm();
    },
  },

  props: {
    students: Map,
    lateTime: Number,
    bufferTime: Number,
    dayKey: String,
  },

  data() {
    return {
      targetSeatNumber: "",
      openConfirm: false,
      seatArray: [
        "",
        "6",
        "",
        "18",
        "",
        "",
        "11",
        "5",
        "10",
        "17",
        "23",
        "25",
        "1",
        "4",
        "9",
        "16",
        "22",
        "24",
        "",
        "3",
        "7",
        "15",
        "21",
        "",
        "",
      ],
    };
  },
})
export default class Student extends Vue {}
